<template>
  <v-content>
    <v-row wrap class="layout">
      <v-col cols="12">
        <h1 class="display-1">
          {{ $t("TERMS_CONDITIONS_HEADER") }}
        </h1>
      </v-col>
      <v-col cols="12" class="tosContent">
        <div v-html="$t('TERMS_CONDITIONS_TEXT')"></div>
      </v-col>
    </v-row>
  </v-content>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class TOS extends BasicComponent {

  created() {

  }

  mounted() {
    this.trackPage("AGB");
  }
}

</script>
<style lang="scss" scoped>

.layout {
  margin-top: 10px;
}

.tosContent {
  margin-top: 25px;
}

</style>
<style lang="scss">

</style>
